import React from 'react';
import { TimelineBlockBox, TimelineBlockDot, TimelineBlockText, TimelineBlockEvents } from './styled';

function TimelineBlock(props) {

    const year = props.year;
    const eventList = props.event;
    const lastYear = props.lastYear;

    return (
        <TimelineBlockBox>

            <TimelineBlockText last={lastYear}>
                <div className="year">{year}년</div>
                <TimelineBlockDot />
                <TimelineBlockEvents last={lastYear}>
                    {eventList.map((event, idx) => {
                        return <div className="event">{event}</div>
                    })}
                </TimelineBlockEvents>
            </TimelineBlockText>

        </TimelineBlockBox>
    );
}

export default TimelineBlock;